export type ScheduleSubmissionListDisplayState = 'draft' | 'pending' | 'revision' | 'waiting_review' | 'completed';

export interface ScheduleSubmissionListStatusDisplay {
  code: string;
  label: string;
  displayState: ScheduleSubmissionListDisplayState;
}

export function normalizeScheduleSubmissionListStatusCode(status: string | null | undefined): string {
  const normalizedStatus = String(status ?? '').trim();

  if (normalizedStatus === 'imported_pending_fix') {
    return 'draft';
  }

  if (normalizedStatus === 'rejected') {
    return 'revision_requested';
  }

  if (normalizedStatus === 'submitted') {
    return 'ready_for_teacher';
  }

  if (normalizedStatus === 'approved') {
    return 'education_head_confirmed';
  }

  return normalizedStatus;
}

export function getScheduleSubmissionListStatusDisplay(
  status: string | null | undefined,
): ScheduleSubmissionListStatusDisplay {
  const code = normalizeScheduleSubmissionListStatusCode(status);
  const displayByCode: Record<string, Omit<ScheduleSubmissionListStatusDisplay, 'code'>> = {
    draft: { label: 'แบบร่าง', displayState: 'draft' },
    ready_for_teacher: { label: 'รอดำเนินการ', displayState: 'pending' },
    special_revision_requested: { label: 'ส่งกลับแก้ไขพิเศษ', displayState: 'revision' },
    revision_requested: { label: 'ส่งกลับแก้ไข', displayState: 'revision' },
    teacher_confirmed: { label: 'รอพิจารณารับรอง', displayState: 'waiting_review' },
    waiting_teacher_submit: { label: 'รอดำเนินการ', displayState: 'pending' },
    waiting_education_head_review: { label: 'รอพิจารณารับรอง', displayState: 'waiting_review' },
    education_head_confirmed: { label: 'รับรองแล้ว', displayState: 'completed' },
    vice_dean_confirmed: { label: 'รับรองแล้ว', displayState: 'completed' },
    locked: { label: 'รับรองแล้ว', displayState: 'completed' },
  };
  const display = displayByCode[code] ?? { label: '-', displayState: 'pending' as const };

  return {
    code,
    ...display,
  };
}
